var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBulletPlusGreen2 = function SvgBulletPlusGreen2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_26773)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CAF4E2",
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10",
    className: "circle"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#037F4C",
    d: "M14.319 9.396q.681 0 .681.593v.044q0 .285-.154.44-.153.13-.527.131h-3.715v3.715q0 .374-.153.527-.133.154-.418.154h-.044q-.594 0-.593-.681v-3.715H5.68q-.374 0-.527-.131Q5 10.318 5 10.033v-.044q0-.594.681-.593h3.715V5.68q0-.681.593-.681h.044q.285 0 .418.154.153.153.153.527v3.715z",
    className: "mark"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_26773"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgBulletPlusGreen2;